import { BoxGameData, LuckyGameData, WheelGameData } from '../games';
import { GameId } from './common';
import { CouponInCampain } from './coupon';
import { Field, Text, Button, Spacer } from './form-fields';

type Colors = {
  bg: string;
};

export type WinScreenSettings = {
  bgColor: string;
  closeButtonColor: string;
  blocks: Array<Text | Button | Spacer>;
};

export type LooseScreenSettings = WinScreenSettings;

export type Campaign = {
  id: number;
  name: string;
  gameId: GameId;
  formFields: {
    fields: Field[];
  };
  active: boolean;
  activeOnDirectLink: boolean;
  widgetBreakDuration: number;
  displayRules: DisplayRules;
  colors: Colors;
  updatedAt: string;
  createdAt: string;
  gameData: BoxGameData | WheelGameData | LuckyGameData;
  useBgImage: boolean;
  bgImageUrl: {
    mobile: string;
    desktop: string;
  };
  wixCoupons: CouponInCampain[];
  winScreen: WinScreenSettings;
  wixInstanceId: string;
  userUuid: string;
  available?: boolean; // only client-side, for games rendered directly to page
  texts?: {
    campaignNotAvailable?: string;
  };
  disabledScreen?: {
    bgColor?: string;
    blocks: Array<Text | Spacer>;
  };
  showBranding?: boolean;
  yaMetrikaIntegration?: {
    counterId?: number;
  };
  integrations?: string[];
};

export type CreateCampaignDto = {
  name: string;
  gameId: GameId;
};

export type UpdateCampaignTitleDto = {
  id: number;
  name: string;
};

export type CopyCampaignDto = {
  id: number;
  name: string;
};

export type DeleteCampaignDto = {
  id: number;
};

export type UpdateCampaignDto = {
  id: number;
  campaign?: Partial<Campaign>;
  gameData?: Partial<BoxGameData> | Partial<WheelGameData>;
};

export type TriggerOpts = {
  imageUrl: string;
  position: TriggerPosition;
  animation: boolean;
  shiftX: number;
  shiftY: number;
  width: number;
  height: number;
  rotate: number;
};

export type TShowStrategy = 'click-to-trigger' | 'auto-open' | 'exit-intent' | 'after-purchase' | 'open-on-event';

export type TShowStrategies = ReadonlyArray<TShowStrategy>;

export type DisplayRules = {
  renderStrategy?: 'popup' | 'page';
  renderElementId?: string;
  showStrategies: TShowStrategies;
  autoOpenDelay: number;
  trigger: {
    mobile: TriggerOpts;
    desktop: TriggerOpts;
  };
  pages: {
    include: PageRule[];
    exclude: PageRule[];
  };
};

export type TriggerPosition = 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right';

export type MatchType = 'equal' | 'contain';

export type PageRule = {
  matchType: MatchType;
  value: string;
};

export const matchTypes: ReadonlyArray<MatchType> = ['equal', 'contain'];

export type WixContactsLabel = {
  id: string;
  label: string;
};

export type CampaignStatistics = {
  showsAmount: number;
  leadsAmount: number;
  conversion: string;
  contactsCreatedAmount: number;
  wixCoupons: Array<{
    couponUuid: string;
    couponName: string;
    amount: string;
  }>;
};
